import { render, staticRenderFns } from "./clone-family-action.vue?vue&type=template&id=7025d336"
import script from "./clone-family-action.vue?vue&type=script&lang=js"
export * from "./clone-family-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports